export const meta = {
  title: 'Notifikasi: apa yang pelanggan anda terima, dan bila',
  updatedAt: '2026-07-17',
  related: ['broadcasts', 'queue-board'],
};

Pelanggan anda tidak berdiri di tingkap memerhati kereta mereka — aplikasi yang memaklumkan mereka. Halaman ini menyenaraikan dengan tepat notifikasi yang wujud, apa yang perlu benar untuk ia sampai, dan apa yang belum dibina.

## Notifikasi automatik

Setiap pergerakan tiket di papan barisan anda menghantar notifikasi kepada pelanggan yang menempah:

- **Masuk barisan** — _"Anda dalam barisan."_
- **Cucian bermula** — _"Sedang dicuci."_
- **Sedia** — _"Sedia untuk diambil."_ Inilah yang membawa mereka kembali ke kaunter.
- **Dibatalkan** — supaya tiada siapa terus menunggu tiket yang sudah tiada.
- **Ditangguhkan** — giliran mereka dijeda, bukan hilang.

Dua lagi yang patut diketahui: apabila satu cucian menaikkan pelanggan ke tahap kesetiaan lebih tinggi, mereka menerima notifikasi tahniah serta-merta. Dan satu yang **tidak** wujud: tiada notifikasi apabila tiket diambil dan dibayar — tiada notifikasi resit. Mata dan sejarah ada dalam aplikasi mereka, tetapi tiada apa yang berbunyi.

## Apa yang perlu benar dahulu

Notifikasi tolak memerlukan kebenaran pelanggan. Aplikasi mereka bertanya pada saat yang munasabah — sejurus selepas mereka menempah, ketika notifikasi jelas berguna — bukan sebagai pop-up dingin pada bukaan pertama. Jika mereka menolak, tiada apa yang rosak: mereka masih boleh melihat tiket bergerak secara langsung dalam aplikasi; cuma tiada maklumat tolak.

## Apa yang pelanggan kawal

Dalam tetapan notifikasi aplikasi mereka, setiap pelanggan memilih:

- **Kemas kini cucian** dan **pemasaran** secara berasingan, ikut saluran.
- **Waktu senyap** — tetingkap malam (22:00–08:00 secara lalai) ketika pemasaran kekal senyap.

Kemas kini status cucian dianggap penting dan sentiasa dihantar selagi notifikasi dibenarkan. Pemasaran menghormati pilihan sepenuhnya: penarikan diri dan waktu senyap dikuatkuasakan pada setiap siaran anda — lihat artikel siaran untuk cara langkauan dilaporkan kepada anda.

## Had yang jujur

- **Teks notifikasi adalah tetap, dan buat masa ini dalam bahasa Inggeris sahaja.** Anda belum boleh menyunting teks notifikasi ikut perniagaan, dan ia belum mengikut bahasa aplikasi pelanggan.
- **WhatsApp dan SMS tidak menghantar apa-apa hari ini.** Togol wujud dalam tetapan pelanggan dan platform telah menyediakan slot integrasi WhatsApp, tetapi tiada mesej WhatsApp atau SMS yang keluar — notifikasi tolak ialah satu-satunya saluran aktif. Apabila sokongan WhatsApp dilancarkan (menggunakan nombor perniagaan anda sendiri), manual ini akan mendapat artikel persediaannya.
